var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86664 7.43716C6.92856 5.13887 10.304 3.6237 11.9929 2.89164C16.815 0.801472 17.817 0.438387 18.4701 0.426397C18.6137 0.42376 18.9349 0.460858 19.1429 0.636779C19.3186 0.785323 19.3669 0.985984 19.39 1.12682C19.4132 1.26766 19.442 1.58848 19.4191 1.83917C19.1578 4.70046 18.0271 11.644 17.4518 14.8487C17.2084 16.2048 16.7292 16.6594 16.2652 16.7039C15.2568 16.8006 14.4911 16.0095 13.5145 15.3423C11.9862 14.2983 11.1229 13.6484 9.63946 12.6297C7.9251 11.4524 9.03644 10.8053 10.0135 9.7478C10.2691 9.47104 14.712 5.25974 14.7979 4.87771C14.8087 4.82993 14.8187 4.65183 14.7172 4.55779C14.6156 4.46375 14.4658 4.49591 14.3576 4.52148C14.2044 4.55774 11.763 6.23938 7.03347 9.5664C6.34049 10.0623 5.71281 10.3039 5.15043 10.2913C4.53045 10.2773 3.33786 9.92594 2.45129 9.62561C1.36388 9.25725 0.499624 9.06249 0.574881 8.4369C0.614079 8.11105 1.04467 7.7778 1.86664 7.43716Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.13de47dbaca3897ce2c0d11a1325478f.svg";
export { ForwardRef as ReactComponent };